'use client'

import AppBar from '@mui/material/AppBar'
import { styled } from '@mui/material/styles'

export const NavigationBar = styled(AppBar)(({ theme }) => ({
  padding: theme.spacing(0.75, 1.5),
  ...theme.typography.caption,
}))

export default {}
